import { render, staticRenderFns } from "./DadosFilescan.vue?vue&type=template&id=7d097e3f&"
import script from "./DadosFilescan.vue?vue&type=script&lang=js&"
export * from "./DadosFilescan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardSubtitle,VSimpleTable})
